module.exports = __webpack_public_path__ + "media/images/icons/edit-b74529237ec173640c97e1d167600bb4.svg";